import { HTMLElement, NodeType } from 'node-html-parser';
import { KinoklubCinema } from '../interfaces/global';
import { resolveCinema } from './global.helper.js';

export const getId = (el: HTMLElement): number => {
  return +el.querySelector('.program__movie-name').attributes['data-projection'];
};

export const getTitle = (el: HTMLElement): string => {
  return el.querySelector('.program__movie-name').textContent.trim();
};

export const getHour = (el: HTMLElement): any => {
  return el.querySelector('.program__hour').textContent;
};

export const getRunning = (el: HTMLElement): boolean => {
  return el.classList.contains('program__info-row--running');
};

export const getTags = (el: HTMLElement): string[] => {
  return el
    .querySelectorAll('.program__tag')
    .map((x) => x.textContent.replace(/(\r\n|\n|\r|\t)/gm, '').trim());
};

export const getPrice = (el: HTMLElement): string => {
  const price = el
    .querySelector('.program__price form')
    ?.textContent?.replace(/(\r\n|\n|\r|\t)/gm, '')
    .trim();

  if (price === 'Vyprodáno' || price === 'Sold out') return 'Sold out';
  if (price === 'Zdarma' || price === 'Free') return 'Free';

  return price;
};

// export const getTicketId = (el: HTMLElement): number | undefined => {
//   return +el.querySelector('.program__price form input[name=eventid]')?.attributes.value;
// };

export const getDay = (el: HTMLElement): string => {
  const parent = el.querySelector('.program__movie-name').closest('.program') as HTMLElement;
  return parent.querySelector('.program__day .desktop').textContent;
};

export const getCinema = (el: HTMLElement): KinoklubCinema | string => {
  const cinema = el.querySelector('.program__place span')?.textContent;
  return resolveCinema(cinema);
};

export const getHall = (el: HTMLElement): string | null => {
  const hallEl = el.querySelector('.program__place');
  if (!hallEl) return null;

  // Get all text nodes only
  for (const node of hallEl.childNodes) {
    if (node.nodeType === NodeType.TEXT_NODE) {
      const text = node.textContent?.trim();
      if (text) return text;
    }
  }

  return null;
};
